module.exports = __webpack_public_path__ + "img/slide2.2f6a5fe1.png";